/**
 * แบรนด์/ธุรกิจ — ทะเบียนแบรนด์ที่ใช้ได้ทั้งระบบ (NO HARDCODE)
 * สร้างธุรกิจใหม่ที่นี่ (เช่น เสื้อยืด) → ทุกเมนู (สี/ไซซ์/ราคา/โปร/คำตอบ/รับออเดอร์) เลือกแบรนด์นี้ได้ทันที
 *
 * ใช้ CrudManager กลาง — เหลือแค่ประกาศ schema (ดู components/CrudManager.tsx)
 */
import { CrudManager, type CrudField } from '@/components/CrudManager';
import { BrandsApi, type BrandItem } from '@/lib/admin-api';

const FIELDS: CrudField[] = [
  { key: 'brand_key', label: 'รหัส (key)', type: 'text', required: true, placeholder: 'tshirt', disabledOnEdit: true, help: 'a-z 0-9 _ เท่านั้น • ใช้ภายใน ห้ามเปลี่ยนภายหลัง' },
  { key: 'name', label: 'ชื่อแสดงผล', type: 'text', required: true, placeholder: 'ร้านเสื้อยืด', help: 'ชื่อที่เห็นในเมนูเลือกแบรนด์' },
  { key: 'emoji', label: 'อิโมจิ', type: 'text', placeholder: '👕', default: '🏢', help: 'ไอคอนสั้นๆ' },
  { key: 'note', label: 'หมายเหตุ', type: 'text', placeholder: 'เสื้อยืดพิมพ์ลาย', help: 'คำอธิบายสั้นๆ (ไม่บังคับ)' },
  { key: 'sort_order', label: 'ลำดับ', type: 'number', default: 0, help: 'เลขน้อยขึ้นก่อน' },
  { key: 'active', label: 'เปิดใช้งาน', type: 'toggle', default: true },
];

export default function BrandsPage() {
  return (
    <CrudManager<BrandItem>
      title="🏢 แบรนด์/ธุรกิจ"
      addLabel="เพิ่มแบรนด์"
      help={
        <span>
          แต่ละแบรนด์มีข้อมูลของตัวเองแยกกัน (สี ไซซ์ ราคา โปร คำตอบบอท การรับออเดอร์).
          เพิ่มธุรกิจใหม่ที่นี่ แล้วทุกเมนูจะเลือกแบรนด์นี้ได้ทันที — ไม่ต้องแก้โค้ด
        </span>
      }
      queryKey="brands"
      api={BrandsApi}
      fields={FIELDS}
      hardDelete
      sortRows={(a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.id - b.id}
      rowTitle={(b) => <>{b.emoji ?? '🏢'} {b.name}</>}
      rowSubtitle={(b) => <>รหัส: <code>{b.brand_key}</code>{b.note ? ` · ${b.note}` : ''}</>}
    />
  );
}
